"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainMenuItem = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.MainMenuItem = styled_components_1.default.li `
  position: relative;
  display: inline-block;
  font-weight: ${props => props.weight};
  color: rgb(102, 102, 102);

  padding: 0 5px;

  ${props => props.locked
    ? `opacity: 0.5;`
    : `
  &:hover {
    background: white;
    cursor: pointer;
  }`};
`;
//# sourceMappingURL=main-menu-item.js.map